export default __webpack_public_path__ + "static/media/sociocredz.ec056bad.png";